import React from 'react';
import '../App.css';

function SchwaziPrivacyPolicy() {
    return (
        <div className="App" style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif' }}>
            {/*<header className="App-header">*/}
            {/*    Privay Policy TappyTime*/}
            {/*</header>*/}
            <h1>Privacy Policy for TappyTime</h1>
            <p><strong>Effective Date:</strong> 2025-05-28</p>

            <h2>1. Information We Do Not Collect</h2>
            <p>
                TappyTime is designed to function without collecting any personally identifiable information (PII). Specifically:
            </p>
            <ul>
                <li>We do not collect names, email addresses, phone numbers, or any other personal details.</li>
                <li>We do not track your location.</li>
                <li>We do not store or transmit any biometric or touch input data beyond the current session.</li>
            </ul>

            <h2>2. App Functionality</h2>
            <p>
                TappyTime determines a random "winner" among multiple users by detecting simultaneous touches on a device screen.
                The touch data is used locally and temporarily only for that single selection and is not stored or transmitted.
            </p>

            <h2>3. No Third-Party Data Sharing</h2>
            <p>
                We do not share any user data with third-party services, advertisers, or analytics providers because no user data is collected in the first place.
            </p>

            <h2>4. Children’s Privacy</h2>
            <p>
                TappyTime is suitable for users of all ages and does not knowingly collect personal information from children under 13.
                If you believe your child has provided personal information inadvertently, please contact us so we can delete it.
            </p>

            <h2>5. Security</h2>
            <p>
                While TappyTime does not collect or transmit any user data, we take standard measures to ensure that the app is safe and free of malicious code.
            </p>

            <h2>6. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy occasionally. Any changes will be posted within the app or on our official website.
                Your continued use of TappyTime after changes are made constitutes acceptance of the new policy.
            </p>

            <h2>7. Contact Us</h2>
            <p>
                If you have any questions about this Privacy Policy or TappyTime’s practices, please contact us at:
            </p>
            <ul>
                <li>Email: info@huurhuishunter.nl</li>
            </ul>
        </div>
    );
};

export default SchwaziPrivacyPolicy;